import "./Curso.css";
import React, { useEffect, useState } from "react";
import SeccionComentarios from "./subcomponents/SeccionComentarios";
import SeccionDocumentos from "./subcomponents/SeccionDocumentos";
import SeccionGeneral from "./subcomponents/SeccionGeneral";
import SeccionLaboral from "./subcomponents/SeccionLaboral";
import SeccionProgramas from "./subcomponents/SeccionProgramas";
import LoadingOverlay from "../0. Utilidades/LoadingOverlay";

import { BsFillPersonLinesFill } from "react-icons/bs";
import { MdWork } from "react-icons/md";
import { HiMiniAcademicCap } from "react-icons/hi2";
import { SlDocs } from "react-icons/sl";
import { GoCommentDiscussion } from "react-icons/go";
import { CiEdit } from "react-icons/ci";

function CursoView({ curso }) {
  const [isLoading, setIsLoading] = useState(true);
  const [cursoData, setCursoData] = useState(null);
  const [activeTab, setActiveTab] = useState("info");

  useEffect(() => {
    if (curso && curso.nombre) {
      // Data already provided — no need to refetch
      setCursoData(curso);
      setIsLoading(false);
    } else {
      const fetchCurso = async () => {
        setIsLoading(true);
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_API}api/perfiles/cursos/${curso.id}/`,
          );
          if (!response.ok) throw new Error("ID not found");
          const data = await response.json();
          setCursoData(data);
        } catch (error) {
          console.error("Error:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchCurso();
    }
  }, [curso]);

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash) {
      setActiveTab(hash);
    }
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      setActiveTab(hash || "info");
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  if (isLoading) return <LoadingOverlay />;

  // Parent can also accept the updated payload directly (no refetch)
  const handleCursoUpdated = (updatedCurso) => {
    // Option A (fast): just replace state with what backend returned
    setCursoData(updatedCurso);

    // Option B (strict): refetch to ensure it's truly fresh
    // refreshCurso();
  };

  return (
    <div id="curso">
      <div className="curso-card">
        <img
          src={
            cursoData.imagen ||
            "https://cdn-redmaestra-endpoint.azureedge.net/static/images/defaultcourse.png"
          }
          alt={curso.nombre || "Default"}
        />

        <div className="curso-card-text">
          <p>
            <strong>Nombre:</strong> {cursoData.nombre}
          </p>
          <p>
            <strong>Oficio:</strong> {cursoData.oficio}
          </p>
          <p>
            <strong>Region:</strong> {cursoData.region}
          </p>
          <p>
            <strong>Comuna:</strong> {cursoData.comuna}
          </p>
        </div>

        <div className="curso-card-text">
          <a
            href={`/api/perfiles/editar_cursos/${cursoData.id}/`}
            className="btn btn-secondary"
          >
            <CiEdit />
          </a>
        </div>
      </div>
      <div className="curso-tabs">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "info" ? "active" : ""}`}
              onClick={() => setActiveTab("info")}
              href="#info"
            >
              <BsFillPersonLinesFill />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "laboral" ? "active" : ""}`}
              onClick={() => setActiveTab("laboral")}
              href="#laboral"
            >
              <MdWork />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "programas" ? "active" : ""}`}
              onClick={() => setActiveTab("programas")}
              href="#programas"
            >
              <HiMiniAcademicCap />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "comments" ? "active" : ""}`}
              onClick={() => setActiveTab("comments")}
              href="#comments"
            >
              <GoCommentDiscussion />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "documents" ? "active" : ""}`}
              onClick={() => setActiveTab("documents")}
              href="#documents"
            >
              <SlDocs />
            </a>
          </li>
        </ul>

        <div className="tab-content">
          {activeTab === "info" && <SeccionGeneral curso={cursoData} />}
          {activeTab === "laboral" && <SeccionLaboral curso={cursoData} />}
          {activeTab === "programas" && (<SeccionProgramas curso={cursoData} onCursoUpdated={handleCursoUpdated} />)}
          {activeTab === "documents" && (
            <SeccionDocumentos cursoId={curso.id} />
          )}
          {activeTab === "comments" && (
            <SeccionComentarios cursoId={curso.id} />
          )}
        </div>
      </div>
    </div>
  );
}

export default CursoView;
